
import { Component, Vue, Prop} from 'vue-property-decorator';
import ChildrenSurvey from "./ChildrenSurvey.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";
import PageBase from "../../PageBase.vue";

import {SearchForChildrenData} from "@/components/utils/ChildrenData/SearchForChildrenData"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
const applicationState = namespace("Application");

@Component({
    components:{
      ChildrenSurvey,
      PageBase
    }
})
export default class ChildrenInfo extends Vue {

    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep =0;
    currentPage =0;
    showTable = true;
    childBestInterestUnderstanding = false;
    childData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;  
    formOneRequired = false;     
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('child-info-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(childValue) {

        const currentIndexValue = this.childData?.length > 0 ? this.childData[this.childData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newChild = { ...childValue, id };
        this.childData = [...this.childData, newChild];

        this.showTable = true; 
        this.resetChildrenRelatedPages(this.childData);
    }

    public deleteRow(rowToBeDeleted) {
       
        this.childData = this.childData.filter(data => {
            return data.id !== rowToBeDeleted;
        }); 
        this.resetChildrenRelatedPages(this.childData);
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.childData = this.childData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
        this.resetChildrenRelatedPages(this.childData);
    }

    public onPrev() {
       Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    created() {

        if (this.step.result?.childrenInfoSurvey) {
            this.childData = this.step.result.childrenInfoSurvey.data;
        }
        if (this.step.result?.childBestInterestAcknowledgement) {
            this.childBestInterestUnderstanding = this.step.result.childBestInterestAcknowledgement;
        }

        if(this.childData?.length == 0){
            this.childData= SearchForChildrenData('FLM');            
        }

        this.formOneRequired = false;

        const stepCOM = this.$store.state.Application.steps[this.stPgNo.COMMON._StepNo]

        if( stepCOM.result?.filingLocationSurvey?.data){
            const filingLocationData = stepCOM.result.filingLocationSurvey.data;
            this.formOneRequired = this.determineFormOneRequired(filingLocationData);            
        }
    }

    mounted(){
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;        
    }

    public determineFormOneRequired(filingLocationData){
        
        let location = ''
        location = filingLocationData?.ExistingCourt;                
        
        if(Vue.filter('includedInRegistries')(location, 'early-resolutions') && (filingLocationData?.MetEarlyResolutionRequirements == 'n')){
            return true;
        } else {
            return false;
        }
    }   

    public surveyHasError(){
        let progress = this.childData.length==0? 50 : 100;
        this.incompleteError =  false;        
        for(const child of this.childData){
            if ((this.formOneRequired && !child.dob) || 
                (!this.formOneRequired && (!child.dob || !child.relation || !child.opRelation || !child.currentLiving))){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }

    public isDisableNext() {
        return (this.childData?.length <= 0 || !this.childBestInterestUnderstanding);
    }

    beforeDestroy() {
        this.surveyHasError();        
        this.UpdateStepResultData({step:this.step, data: {childrenInfoSurvey: this.getChildrenResults(), childBestInterestAcknowledgement:this.childBestInterestUnderstanding}})       
    }

    public getChildrenResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        for(const child of this.childData)
        {
            questionResults.push({name:'childInfoSurvey', value: this.getChildInfo(child), title:'Child '+child.id +' Information', inputType:''})
        }
        
        return {data: this.childData, questions:questionResults, pageName:'Children Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getChildInfo(child){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+Vue.filter('getFullName')(child.name));
        resultString.push(Vue.filter('styleTitle')("Birthdate: ")+Vue.filter('beautify-date')(child.dob))
        if (!this.formOneRequired){
            resultString.push(Vue.filter('styleTitle')("Your relationship: ")+child.relation)
            resultString.push(Vue.filter('styleTitle')("Other party’s relationship: ")+child.opRelation)
            if (child.currentLiving == 'other'){
                resultString.push(Vue.filter('styleTitle')("Living with: ")+child.currentLivingComment)
            } else {
                resultString.push(Vue.filter('styleTitle')("Living with: ")+child.currentLiving)
            }
        }        
        
        return resultString
    }

    public resetChildrenRelatedPages(childData?) {
    
        const stPgNo: stepsAndPagesNumberInfoType = this.$store.state.Application.stPgNo;   
        const p = stPgNo.FLM;

        const pages = [
            p.ParentingArrangements,
            p.ParentalResponsibilities,
            p.ParentingTime,
            p.ParentingOrderAgreement,
            p.BestInterestsOfChild,
            p.ChildSupportCurrentArrangements,
            p.AboutChildSupportOrder,
            p.SpecialAndExtraordinaryExpenses,
            p.ContactWithChild,
            p.ContactWithChildOrder,
            p.AboutContactWithChildOrder,
            p.ContactWithChildBestInterestsOfChild,
            p.GuardianOfChild,
            p.ReviewYourAnswersFLM
        ]
        Vue.filter('setProgressForPages')(p._StepNo, pages,50);    

    }
}
